import styled from 'styled-components'
import PointerC from 'assets/images/Pointer.svg'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 1.6rem 2.4rem;

  background-color: var(--light);
  border: 1px solid var(--grey-400);
  border-radius: 0.6rem;
  width: 100%;
`

export const MainText = styled.div`
  color: var(--text-dark);
  font-size: 1.6rem;
  line-height: 2.4rem;
  font-weight: 500;
`

export const SecondaryText = styled(MainText)`
  color: var(--text-light);
  font-size: 1.4rem;
`

export const IconContainer = styled.div`
  --size: 3.4rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--size);
  height: var(--size);
  background-color: var(--white-100);
  border-radius: 50%;
  cursor: url(${PointerC}), pointer;
`
